// MARK: Basic applicant details
export interface IApplicantDetails {
  applicantId: number;
  profileUrl?: string;
  email: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  pronouns?: string;
  dateOfBirth: string;
  ageOnJuneFirst: number;
  applicationCountry: string; // Code
  nationalityCountry?: string; // Code; use lookup to get name
  residenceCountry?: string; // Code
  birthCountry?: string; // Code
  religionCode?: string;
  religionName?: string;
  religionLevel?: number; // 1,2,3 or unset

  otherName?: string;
  otherNameReason?: string;

  emergencyContactName?: string;
  emergencyContactRelationship?: string;
}

export class ApplicantDetails implements IApplicantDetails {
  applicantId: number;
  profileUrl?: string;
  email: string;
  phone?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  pronouns?: string;
  dateOfBirth: string;
  ageOnJuneFirst: number = 0;
  nationalityCountry?: string; // Code; use lookup to get name
  applicationCountry: string; // Code
  residenceCountry?: string; // Code
  birthCountry?: string; // Code
  religionCode?: string;
  religionName?: string;
  religionLevel?: number; // 1,2,3 or unset

  otherName?: string;
  otherNameReason?: string;

  emergencyContactName?: string;
  emergencyContactRelationship?: string;

  constructor(
    applicantId: number,
    firstName: string,
    lastName: string,
    email: string,
    dateOfBirth: string,
    ageOnJuneFirst: number,
    applicationCountry: string,
    profile?: string
  ) {
    this.applicantId = applicantId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.dateOfBirth = dateOfBirth;
    this.ageOnJuneFirst = ageOnJuneFirst;
    this.applicationCountry = applicationCountry;
    this.profileUrl = this.profileUrl ?? undefined;
  }
}

// MARK: Basic application details
export enum ApplicationType {
  FirstTimer = 'First-timer',
  Repeat = 'Repeat',
  Returner = 'Returner',
}

export interface IApplicationDetails {
  id: number;
  season: number;
  userState: string;
  fulltimeStudent: boolean;

  programme?: string;
  earliestAvailability?: string;
  dateDueHome?: string;

  applicationType: ApplicationType;

  placedAtEvent: boolean;
  interviewerId?: number;
  interviewId?: number;
  eventId?: number;

  interviewCopied: boolean;

  confirmStressLetter?: boolean;
}

export class ApplicationDetails implements IApplicationDetails {
  id: number;
  season: number;
  userState: string;
  fulltimeStudent: boolean;

  programme?: string;
  earliestAvailability?: string;
  dateDueHome?: string;

  applicationType: ApplicationType;
  placedAtEvent: boolean;
  interviewerId?: number;
  interviewId?: number;
  eventId?: number;

  interviewCopied: boolean;

  confirmStressLetter = false;

  isDoctorLetterRequired: boolean;

  constructor(
    applicationId: number,
    season: number,
    state: string,
    type: ApplicationType,
    fulltimeStudent: boolean,
    interviewCopied: boolean,
    isDoctorLetterRequired: boolean
  ) {
    this.id = applicationId;
    this.applicationType = type;
    this.season = season;
    this.userState = state;
    this.fulltimeStudent = fulltimeStudent;
    this.interviewCopied = interviewCopied;
    this.isDoctorLetterRequired = isDoctorLetterRequired;

    this.placedAtEvent = false;
  }
}

export type ApplicationMiniSummaryElement = {
  name: string;
  value: string;
};
